<template>
  <BaseModal
    :id="`modalDeleteComment__${forumThread.id}`"
    title="Delete this comment"
    size="md"
    :show.sync="$show"
  >
    <p class="text-dark">Are you sure that you want to delete this comment?</p>

    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide"> Cancel </b-button>
      <b-button variant="danger" @click.prevent="deleteForumThread"> Delete </b-button>
    </template>
  </BaseModal>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin';
import ForumThreads from '@/models/ForumThreads';
import BaseModal from '@/components/base-components/BaseModal';
import Forum from '@/models/Forum';

export default {
  name: 'DeleteForumThreadModal',

  components: {
    BaseModal
  },

  mixins: [notificationMixin],

  props: {
    show: {
      type: Boolean,
      default: false
    },

    forumThread: {
      type: ForumThreads,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },

  methods: {
    async deleteForumThread() {
      try {
        const { forumThread } = this;

        await forumThread.delete();

        this.$toast.success('The comment was deleted');

        if (forumThread.isReplyThread) {
          await ForumThreads.api().getForumThreadById(
            forumThread.forum_id,
            forumThread.main_forum_thread_id
          );
        }

        await Forum.api().fetchById(forumThread.forum_id);

        this.$emit('delete:sucess');
      } catch (error) {
        console.log(error);

        this.$toast.error('Cannot delete comment, please try again');
      } finally {
        this.hide();
      }
    },

    hide() {
      this.$bvModal.hide(`modalDeleteComment__${this.forumThread.id}`);
    }
  }
};
</script>

<style lang="scss" scoped></style>
